module.exports = __webpack_public_path__ + "static/img/log.aab87d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/log.png
// module id = /CSb
// module chunks = 16